import { useQuery } from "@tanstack/react-query";
import { listAgentPhoneCallsAdmin, type ListAgentPhoneCallsAdminParams } from "./agentCallsAdminApi";

export function useAgentPhoneCallsAdmin(params: ListAgentPhoneCallsAdminParams) {
  return useQuery({
    queryKey: ["admin", "agent-calls", params],
    queryFn: ({ signal }) => listAgentPhoneCallsAdmin(params, signal),
  });
}
